// Чтение и запись привязки принтера (T-031).
//
// Решение владельца D2: привязка живёт ТОЛЬКО локально, в Preferences устройства.
// Настройка принтера на кухне часто идёт без сети, а сам принтер стоит в полуметре —
// требовать сеть, чтобы их связать, бессмысленно. Серверная копия остаётся возможной
// позже и ничего здесь не ломает.
//
// Ключ помечен `lifetime: 'device'` (preferenceKeys.ts): принтер принадлежит СТАНЦИИ,
// не человеку — выход повара привязку не стирает.

import { Preferences } from '@capacitor/preferences';

import { PREFERENCE_KEYS } from '@/shared/storage/preferenceKeys';

import type { PrinterBinding } from './useAdapter';

// Копия в памяти: `resolvePrinterAdapter` вызывается на рендере и не может ждать
// асинхронного чтения с диска. `mirrored: true` в реестре — ровно про это.
// `undefined` — ещё не грузили; `null` — грузили, привязки нет.
let cache: PrinterBinding | null | undefined;

/** Прогреть копию в памяти. Зовётся один раз при старте приложения. */
export async function loadPrinterBinding(): Promise<PrinterBinding | null> {
  const { value } = await Preferences.get({ key: PREFERENCE_KEYS.printerBinding });
  cache = value ? (JSON.parse(value) as PrinterBinding) : null;
  return cache;
}

/** Синхронно — из копии в памяти. До `loadPrinterBinding` вернёт `null`. */
export function getPrinterBinding(): PrinterBinding | null {
  return cache ?? null;
}

export async function savePrinterBinding(binding: PrinterBinding): Promise<void> {
  cache = binding;
  await Preferences.set({
    key: PREFERENCE_KEYS.printerBinding,
    value: JSON.stringify(binding),
  });
}

export async function clearPrinterBinding(): Promise<void> {
  cache = null;
  await Preferences.remove({ key: PREFERENCE_KEYS.printerBinding });
}

/** Пометить привязку прошедшей пробную печать. */
export async function markPrinterVerified(): Promise<void> {
  const current = getPrinterBinding();
  if (!current) return;
  await savePrinterBinding({ ...current, verifiedAt: new Date().toISOString() });
}
